import { useMutation } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useDownloadFile = () => {
  
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async ({ url }) => {
      const result = await restClient({ 
        url: `${prefix}/download`, 
        method: 'post',
        data: { url },
        responseType: 'blob'
      });
      return result.data; 
    },
    onSuccess: async () => {
    }
  });
};